import { FC, ReactNode } from 'react';
import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';

export interface IFormStepQuestionProps extends Omit<StackProps, 'title'> {
	title: ReactNode;
	rightSection?: ReactNode;
	titleProps?: TypographyProps;
	titleSectionProps?: StackProps;
}

export const FormStepQuestion: FC<IFormStepQuestionProps> = ({
	title,
	rightSection,
	titleProps: { sx: titleSx, ...titleProps } = {},
	titleSectionProps,
	children,
	...props
}) => {
	return (
		<Stack direction="column" {...props}>
			<Stack direction="row" justifyContent="space-between" spacing={2} {...titleSectionProps}>
				<Typography sx={{ marginBottom: 3, ...titleSx }} {...titleProps}>
					{title}
				</Typography>
				{rightSection}
			</Stack>
			{children}
		</Stack>
	);
};
